<template>
    <div>
        <!-- 面包屑组件 -->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
            <el-breadcrumb-item>校区管理</el-breadcrumb-item>
            <el-breadcrumb-item>校区列表</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 内容卡片 -->
        <el-card>
            <!-- 查询框 -->
            <el-row :gutter="24">
                <el-col :span="4">
                  <el-input
                    v-model="queryInfo.storeName"
                    placeholder="请输入校区名称"
                    clearable
                  >
                  </el-input>
                </el-col>
                <el-col :span="10">
                    <el-button @click="handleSearch" type="primary">搜索</el-button>
                    <el-button @click="handleAdd" type="success">新增</el-button>
                </el-col>
            </el-row>
            <el-table :data="dataList" stripe>
                <el-table-column type="index" label="序号" width="80"></el-table-column>
                <el-table-column label="校区名称" width="335" prop="storeName"></el-table-column>
                <el-table-column label="员工数量" width="150" prop="teacherNum"></el-table-column>
                <el-table-column label="学员数量" width="150" prop="studentNum"></el-table-column>
                <el-table-column label="操作" width="155">
                    <template slot-scope="scope">
                        <el-button @click="handleEdit(scope.row)" type="text" style="color:#FF9F00">编辑</el-button>
                        <el-button @click="handleDelete(scope.row)" type="text" style="color:#F53F3F">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 页数码 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="queryInfo.pageNo"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="queryInfo.pageSize"
                :total="total"
                background
            ></el-pagination>
        </el-card>
    </div>
</template>

<script>
    export default {
        data() {
            return{
                dataList: [],
                queryInfo: {
                    storeName: null,
                    pageSize: 10,
                    pageNo: 1,
                },
                total: 0,
                selectList: []
            }
        },
        mounted() {
            this.initData();
        },
        methods:{
            async initData() {
                const { data: res } = await this.$http.post("/ea/student/store/list",this.queryInfo);
                    if(res.code == 200){
                        this.dataList = res.result.records;
                        this.total = res.result.total;
                    }else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type:'error'
                        });
                    }
            },
            handleSearch() {
                this.initData();
            },
            handleAdd() {
                this.$router.push("/createStore");
            },
            handleClear() {
                this.queryInfo.storeName = null;
            },
            // 套装页码切换
            handleCurrentChange(pageNum){
                this.queryInfo.pageNo = pageNum;
                this.initData();
            },
            handleSizeChange(val) {
                this.queryInfo.pageSize = val;
            },
            handleEdit(record) {
                this.$router.push({
                    name: "createStore",
                    params: {recordDate:record,type:'edit'}
                });
            },
            handleDelete(row) {
                this.$confirm('确认删除该校区吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteStore(row);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            // 课程删除
            async deleteStore(row){
                let idModel = {
                    id:row.id
                }
                const { data: res } = await this.$http.post(`/ea/student/store/delete`,idModel);
                if (res.code !== 200)
                return this.$message.error(res.message);
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });
                this.initData();
            },
        }
    }
</script>

<style scoped>

</style>
